// components/topNavbar.tsx
import React from "react";
import { useNavigate } from "react-router-dom";
import { useTopBar } from "../../../context/TopBarContext";
import { ReactComponent as ArrowDown } from "../../../assets/icons/svg/arrow-down-color.svg";
import { ReactComponent as Bell } from "../../../assets/icons/svg/Bell-icon.svg";
import { ReactComponent as ArrowLeft } from "../../../assets/icons/svg/arrow-left.svg";

const TopNavBar: React.FC = () => {
  const navigate = useNavigate();
  const { title, showBackButton, popNavState, setTitle, setShowBackButton } =
    useTopBar();

  const handleBack = () => {
    const prevState = popNavState();
    if (prevState) {
      setTitle(prevState.title);
      setShowBackButton(prevState.showBackButton);
    }
    navigate(-1);
  };

  return (
    <div className="w-full h-[70px] 3xl:h-[116px]  flex justify-between items-center px-6 bg-white border border-gray-50 shadow-sm">
      <div className="flex items-center gap-2">
        {showBackButton && (
          <button
            onClick={handleBack}
            className="text-[#0091AF] hover:bg-[#F0F9FB] rounded-full p-1"
          >
            <ArrowLeft className="w-5 h-5" />
          </button>
        )}
        <h1 className="text-base 2xl:text-lg 3xl:text-xl 5xl:text-2xl font-medium text-[#1F1F1F] truncate">
          {title}
        </h1>
      </div>

      <div className="flex items-center gap-4">
        <div className="flex items-center space-x-1 text-[#257889] cursor-pointer">
          <span>36 downtown brew pub</span>
          <ArrowDown />
        </div>
        <button
          className="rounded-[10px] text-blue-500 flex items-center justify-center w-[46px] h-[46px] hover:bg-blue-50 transition"
          style={{ borderWidth: "0.5px", borderColor: "#0091AF" }}
          aria-label="Notifications"
        >
          <Bell className="w-5 h-5" />
        </button>
      </div>
    </div>
  );
};

export default TopNavBar;
